<template>
    <div class="cases-listing-table">
			<b-row class="mb-4 mx-3 filter-buttons">
            <b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :pressed="selectedButton === 'All'"
                    class="mb-2 mr-2 shadow-none bg-dark"
                    @click="filterByStatus('')"
                >
                    <p class="text-white">All</p>
                    <!-- removed count display -->
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1">
                <b-button 
                    block
                    :pressed="selectedButton === 'no_status'"
                    class="mb-2 mr-2 shadow-none"
                    variant="outline-primary"
                    @click="filterByStatus('no_status')"
                >
                    <p>No Status</p>
                    <!-- removed count display -->
                </b-button>
            </b-col>
            <b-col cols="6" md="auto" class="px-1" v-for="(item,index) in list_main_personal_loan_status" :key="index">
                <b-button 
                    block
                    :pressed="selectedButton === item.status"
                    variant="outline-primary"
                    class="mb-2 mr-2 shadow-none"
                    @click="filterByStatus(item.status)"
                >
                    <p>{{ item.status }}</p>
					<!-- removed count display -->
                </b-button>
            </b-col>
        </b-row>
        
        
        <b-row class="d-flex justify-content-md-between">
            <b-col cols="12">
                <b-row class="d-flex justify-content-end">
                    <b-col cols="12" md="auto" class="float-right text-right">
												<p>Total Loan Amount</p>
                        <h3 class="text-primary font-weight-600">RM {{ _gHlp.getValue(summary,'total.loan_amount',0) | moneyFormatter }}</h3>
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <PersonalLoanTable :tableData="tableData" :tablePagination="tablePagination" :tableSummary="summary" :tableFilters="tableFilters" ref="personalLoanTableRef" @onFilter="onFilter($event)"/>
    </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import PersonalLoanTable from '@/views/Cases/CasesTables/PersonalLoan/PersonalLoanTable.vue'
import { mapState } from 'pinia'
import { useLookupStore } from '@/stores/lookupStore'

export default {
    props:['tableData','tablePagination','tableSummary','tableFilters'],
    components: {
        PersonalLoanTable,
        [Select.name]: Select,
        [Option.name]: Option,
    },
    data() {
        return {
          summary:{},
					filters:{
						search : {
							prod_main_status:'all'
						}
          },
          selectedButton: 'All',
					selectedSubButton: 'All',
        }
    },
    computed:{
				...mapState(useLookupStore, ['list_main_personal_loan_status','list_sub_personal_loan_status']),
        filteredTableData() {
            if (!this.tableData || !Array.isArray(this.tableData)) {
                return [];
            }
            
            const excludedStatuses = ['Cancel', 'Cancelled', 'Rejected', 'Pending Accept'];
            
            // If "Cancelled", "Pending Accept", or "Rejected" is selected, show only those
            const showOnlyStatuses = ['Cancelled', 'Pending Accept', 'Rejected'];
            if (showOnlyStatuses.includes(this.selectedButton)) {
                return this.tableData.filter(item => {
                    const mainStatus = _gHlp.getValue(item, 'prod_main_status', '');
                    return mainStatus === this.selectedButton;
                });
            }
            
            // For "All" tab and all other status filters, exclude the terminal statuses
            return this.tableData.filter(item => {
                const mainStatus = _gHlp.getValue(item, 'prod_main_status', '');
                return !excludedStatuses.includes(mainStatus);
            });
        }
    },
    watch:{
				tableFilters:{
            handler(newVal){
						this.filters = {...this.filters, ...newVal};
            },
            immediate: true
       },    
			 tableSummary:{
					handler(newVal){
						this.summary = newVal;
					},
					immediate: true
       }
    },
    methods: {
				filterByStatus(sts) {
					this.selectedButton = !_gHlp.isEmpty(sts) ? sts : 'All';
					this.filters.search.prod_main_status = sts
					this.filters.is_reset_summary = false
					this.filters.page = 1
					this.$emit('onFilter',this.filters);
        },
				onFilter(event) {
					this.filters = {...this.filters,...event}
          this.$emit('onFilter',this.filters);
				}
    },
}
</script>